import React from 'react';
import { painPoints } from '../data/content';
export function WhySection() {
  return <section className="bg-mist px-3 py-4 sm:px-6" data-id="element-174" data-mp="13v04hm1412si">
      <div className="mx-auto max-w-2xl" data-id="element-175" data-mp="13vjf0hofkowi">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-navy sm:text-[2rem]" data-id="element-176" data-mp="18umk224euv4h">
          DOES THIS SOUND <span className="text-electric" data-id="element-177" data-mp="1dmntlga727qt">FAMILIAR?</span>
        </h2>
        <p className="mt-1.5 text-center text-[0.8rem] leading-[1.4] text-navy/80 sm:text-[0.95rem]" data-id="element-178" data-mp="1ikxp5rztzacy">
          You arrive at a pool or spa with an equipment problem—but pumps, filters, heaters, valves,
          plumbing, electrical controls and circulation systems can all produce similar symptoms, making
          it difficult to know where to start.
        </p>
        <div className="mt-2 space-y-1.5" data-id="element-179" data-mp="3tc7ajve1basz">
          {painPoints.map(p => <div key={p.title} className="rounded-r-md border-l-4 border-electric bg-white py-2 pl-2.5 pr-2 shadow-sm" data-id="element-180" data-mp="3tebpd8dh1u81">
              <h3 className="font-display text-[0.74rem] font-extrabold uppercase leading-tight text-navy sm:text-[0.92rem]" data-id="element-181" data-mp="2ifn27zn3s2ua">
                {p.title}
              </h3>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-navy/75 sm:text-[0.9rem]" data-id="element-182" data-mp="2dnltgnp58u90">{p.body}</p>
            </div>)}
        </div>
      </div>
    </section>;
}